import { useIsMobile } from '@hts/shared/libs';
import { IMappedButton } from '@hts/shared/types';
import { shouldRenderOnCurrentView } from '@hts/shared/utils';
import { useMemo } from 'react';

export const useGetButtons = (buttons?: IMappedButton[]) => {
  const isMobile = useIsMobile();

  return useMemo(
    () =>
      buttons?.filter(({ shouldShowOnDesktop, shouldShowOnMobile }) =>
        shouldRenderOnCurrentView(isMobile, shouldShowOnDesktop, shouldShowOnMobile)
      ) ?? [],
    [isMobile, buttons]
  );
};
